import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { ErrorEventArgs } from '../../../models/event-args/global-error.event.args';
import { ssApiService } from '../../../services/ss-api.service';
import { GlobalService } from '../../../services/global.service';
import { Subscription } from 'rxjs';
import { HttpError } from '../../../models/errors/HttpError';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TwoFactorAuthenticationRequest } from '../../../models/ss-api/requests/two.factor.authentication.request';

@Component({
    selector: 'twofactor-code',
    templateUrl: './twofactor-code-form.component.html'
})
export class TwoFactorCodeFormComponent implements OnInit {

    // events
    @Output('onBusyChanged') onBusyChanged = new EventEmitter<Boolean>();
    @Output('onCancel') onCancel = new EventEmitter();
    @Output('onError') onError = new EventEmitter<ErrorEventArgs>();
    @Output('onAuthenticated') onAuthenticated = new EventEmitter<IBaseResponse<any>>();

    // form
    codeForm: FormGroup

    // private
    showTimeout: boolean = true;

    constructor(private api: ssApiService, private gb: GlobalService) {

    }

    ngOnInit() {
        this.codeForm = new FormGroup({
            'code': new FormControl(null, [Validators.required, Validators.minLength(4)]),
            'RememberDevice': new FormControl(true)
        })
    }

    Cancel() {
        this.onCancel.emit();
    }

    private ResetSigninFormSubmitRequest(request: Subscription) {
        request.unsubscribe();
        this.showTimeout = false;
        this.onBusyChanged.emit(false);
    }

    async CodeSubmit() {


        this.onBusyChanged.emit(true);


        let data = new TwoFactorAuthenticationRequest();
        data.Code = this.codeForm.get('code').value;
        data.Token = this.gb.Token;

        data.RememberDevice = this.codeForm.get('RememberDevice').value;
        data.DeviceID = localStorage.getItem('DeviceID');
        if (data.DeviceID == null || data.DeviceID == undefined)
            data.DeviceID = "";
      

        let request = this.api.TwoFactorAuthentication(data)
            .subscribe(response => {
                this.ResetSigninFormSubmitRequest(request);


                if (!response.Result) {
                    // error
                    this.onError.emit(new ErrorEventArgs('0', response.Message, response.Message, 'Error'));
                    return;
                }
                

                console.log("authenticated:", response.Data);
                localStorage.setItem('is_authenticated', "1");
                this.gb.SetGlobalsFromLoginResponse(response.Data);
                this.gb.ReadFromStorage();                
                  
                // setup user roles
                this.gb.LoadSignature();
                this.gb.SetupUserRole();
                this.gb.GetGravatar();          

                this.onAuthenticated.emit(response);
            },


            (error: HttpError) => {
                this.ResetSigninFormSubmitRequest(request);

                this.onError.emit(new ErrorEventArgs('0', error.OriginalError, error.FriendlyMessage, error.FriendlyTitle));
            }
            );


        // set timeout
        //this.showTimeout = true;

        //setTimeout(() => {

        //    this.ResetSigninFormSubmitRequest(request);

        //    if (this.showTimeout)
         //       this.onError.emit(new ErrorEventArgs('0', 'timeout', 'Error connecting to server. Please try again later.', 'Timeout Error'));

        //}, this.gb.HttpTimeout);

    }


}
